export default "__VITE_ASSET__r3DawZW$__"